import Vue from "vue";
import * as types from "./mutation-types";
import Cookies from "js-cookie";

/* eslint-disable */
export default {

  [types.LOAD_CONFIG](state, { data }) {

    Cookies.set("appName", data.appName);
    Cookies.set("appEditeur", data.appEditeur);
    Cookies.set("appVersion", data.appVersion);
    Cookies.set("appTimeZone", data.appTimeZone);
    Cookies.set("appDateFormat", data.appDateFormat);
    Cookies.set("appHeureFormat", data.appHeureFormat);
    Cookies.set("appDevise", data.devise);
    Cookies.set("tva", data.tva);
    if( data !== null){
      Cookies.set("isLoad", true);
        Vue.set(state, "isLoad", data.true);
    }

    Vue.set(state, "appName", data.appName);
    Vue.set(state, "appEditeur", data.appEditeur);
    Vue.set(state, "appVersion", data.appVersion);
    Vue.set(state, "appTimeZone", data.appTimeZone);
    Vue.set(state, "appDateFormat", data.appDateFormat);
    Vue.set(state, "appHeureFormat", data.appHeureFormat);
    Vue.set(state, "appDevise", data.devise);
    Vue.set(state, "tva", data.tva);
  },

  [types.SET_LOADER](state, { isLoading, fullPage, canCancel }) {
      state.isLoading = isLoading;
      state.fullPage = fullPage;
      state.canCancel = canCancel;
  },
  [types.SET_LOCALE](state, { locale }) {
      Cookies.set("locale", locale);
      state.locale = locale;
  }
};
